import * as NiftyInvoices from "./niftyInvoice";
export default NiftyInvoices;
